import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "none",
  viewBox: "0 0 49.8 34.8"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0 17.4h49.9",
      "vector-effect": "non-scaling-stroke"
    }, null, -1),
    _createElementVNode("path", {
      fill: "none",
      d: "m16.9 34.4-17-17 17-17",
      "vector-effect": "non-scaling-stroke"
    }, null, -1)
  ]))]))
}
export default { render: render }